module.exports = __webpack_public_path__ + "img/PrayerBG.a04b8616.jpg";